import axios from "axios";

// In the browser we always talk to the SAME ORIGIN as the page itself.
// This avoids CORS entirely on custom domains (e.g. www.yonsii.com) and
// means the deployed site works even though the baked-in build-time
// REACT_APP_BACKEND_URL still points at the preview host.
const envUrl = process.env.REACT_APP_BACKEND_URL || "";
export const BACKEND_URL =
  typeof window !== "undefined" && window.location && window.location.origin
    ? window.location.origin
    : envUrl;

export const API = `${BACKEND_URL}/api`;

export const TOKEN_KEY = "yonsii_token";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
